import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

/**
 * A pipe that sanitizes content to prevent XSS attacks.
 * @param value - The content to be sanitized.
 * @returns The sanitized content.
 */
@Pipe({
  name: 'safe',
  pure: true,
  standalone: true
})
export class SafePipe implements PipeTransform {

  /**
   * Creates an instance of SafePipe.
   * @param sanitized - The Angular `DomSanitizer` service used to sanitize the HTML string.
   */
  constructor(protected sanitizer: DomSanitizer) {}
 
  /**
 * Bypasses Angular's built-in security and marks the specified HTML as safe.
 * Use with caution as this can lead to XSS vulnerabilities.
 * @param value - The string to mark as safe.
 * @param type - The type of value to be sanitized.
 * @returns A SafeHtml object that can be used to display the content without sanitization.
 */
 public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
			case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
			case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
			case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
			case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
			case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
			default: throw new Error(`Invalid safe type specified: ${type}`);
		}
  }
}